import { simpleFetch as fetcher } from '@api/fetchers';
import { getHost } from '@utils/api-helper/host';

const defaultHost = getHost();

export const getFeedAPI = ({ goalUID, limit = 3, offset = 0 }) =>
  `${defaultHost}v1/uplus/special_class/home/?goal_uid=${goalUID}&limit=${limit}&offset=${offset}&v=10`;

export const fetchSpecialClassesFeed = async ({
  goalUID,
  limit = 3,
  offset = 0
}) => {
  return fetcher(getFeedAPI({ goalUID, limit, offset }));
};
